/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.2.4 bird_animations_alex.glb
Author: ahitch3 (https://sketchfab.com/ahitch3)
License: CC-BY-4.0 (http://creativecommons.org/licenses/by/4.0/)
Source: https://sketchfab.com/3d-models/bird-animations-alex-081fa7f0cfd649b9b07babb4c619acc7
Title: Bird Animations Alex
*/
import * as THREE from"three";
import React, { useEffect, useRef } from 'react'
import { useGLTF, useAnimations } from '@react-three/drei'

export function BirdAvatar(props) {
  const group = useRef()

  const { nodes, materials, animations } = useGLTF('models/bird_animations_alex.glb')
  const { actions } = useAnimations(animations, group)
  useEffect(()=>{
    console.log(actions);
    actions.fly1_bird.play();
  })
  return (
    <group ref={group} {...props} dispose={null}>
      <group name="Sketchfab_Scene">
        <group name="Sketchfab_model" rotation={[-Math.PI / 2, 0, 0]} scale={14.42}>
          <group name="ddd66ab4b0fb49f18c2e85493cc58f8dfbx" rotation={[Math.PI / 2, 0, 0]} scale={0.01}>
            <group name="Object_2">
              <group name="RootNode">
                <group name="Object_4">
                  <primitive object={nodes._rootJoint} />
                  <group name="Object_6" />
                  <group name="Object_8" />
                  <group name="Object_10" />
                  <group name="Object_12" />
                  <group name="Object_14" />
                  <group name="Object_16" />
                  <group name="Object_18" />
                  <group name="Object_20" />
                  <group name="Object_22" />
                  <group name="Object_24" />
                  <group name="Object_26" />
                  <group name="CK_skin_body" />
                  <group name="head_fur" />
                  <group name="Small_fur" />
                  <group name="Neck_fur" />
                  <group name="back" />
                  <group name="small_fur" />
                  <group name="mid_fur_front" />
                  <group name="Larg_wings_2" />
                  <group name="back_neck_fur" />
                  <group name="Larg_wimgs" />
                  <group name="med_fur_back" />
                  <skinnedMesh name="Object_7" geometry={nodes.Object_7.geometry} material={materials.body} skeleton={nodes.Object_7.skeleton} />
                  <skinnedMesh name="Object_9" geometry={nodes.Object_9.geometry} material={materials.body} skeleton={nodes.Object_9.skeleton} />
                  <skinnedMesh name="Object_11" geometry={nodes.Object_11.geometry} material={materials.body} skeleton={nodes.Object_11.skeleton} />
                  <skinnedMesh name="Object_13" geometry={nodes.Object_13.geometry} material={materials.body} skeleton={nodes.Object_13.skeleton} />
                  <skinnedMesh name="Object_15" geometry={nodes.Object_15.geometry} material={materials.body} skeleton={nodes.Object_15.skeleton} />
                  <skinnedMesh name="Object_17" geometry={nodes.Object_17.geometry} material={materials.body} skeleton={nodes.Object_17.skeleton} />
                  <skinnedMesh name="Object_19" geometry={nodes.Object_19.geometry} material={materials.body} skeleton={nodes.Object_19.skeleton} />
                  <skinnedMesh name="Object_21" geometry={nodes.Object_21.geometry} material={materials.body} skeleton={nodes.Object_21.skeleton} />
                  <skinnedMesh name="Object_23" geometry={nodes.Object_23.geometry} material={materials.body} skeleton={nodes.Object_23.skeleton} />
                  <skinnedMesh name="Object_25" geometry={nodes.Object_25.geometry} material={materials.body} skeleton={nodes.Object_25.skeleton} />
                  <skinnedMesh name="Object_27" geometry={nodes.Object_27.geometry} material={materials.body} skeleton={nodes.Object_27.skeleton} />
                </group>
              </group>
            </group>
          </group>
        </group>
      </group>
    </group>
  )
}

useGLTF.preload('models/bird_animations_alex.glb')
